import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import Loading from '../Loading';
import * as styles from './FullPageLoader.scss';

/**
 * Reusable FullPageLoader Component
 * @function FullPageLoader
 * @param {Object} props
 * @return {ReactElement}
 */
const FullPageLoader = props => {
  const { className, loaderClassName, loaderStyle, style, text = 'Loading...' } = props;

  return (
    <div className={classNames(styles.fullPageLoader, className)} style={style}>
      <Loading
        className={classNames(styles.loadingComponent, loaderClassName)}
        style={loaderStyle}
        text={text} />
    </div>
  );
};

FullPageLoader.propTypes = {
  className: PropTypes.string,
  loaderClassName: PropTypes.string,
  loaderStyle: PropTypes.objectOf(
    PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
    ])
  ),
  style: PropTypes.objectOf(
    PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
    ])
  ),
  text: PropTypes.string,
};

export default FullPageLoader;
